import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigService } from '@app/configuration/config.service';
import { MaintenanceModeService } from '../services/maintenance-mode.service';

@Injectable()
export class MaintenanceModeInterceptor implements HttpInterceptor {
  constructor(
    private readonly maintenanceModeService: MaintenanceModeService,
    private readonly configService: ConfigService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const apiUrl = this.configService.getConfig()?.apiUrl ?? '';
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 503 && request.url.startsWith(apiUrl)) {
          const retryAfter = request.headers.get('Retry-After');

          this.maintenanceModeService.isMaintenanceMode = true;
          this.maintenanceModeService.retryAfter = retryAfter;
        } else {
          return throwError(err);
        }
      }),
      map((response) => {
        if (this.maintenanceModeService.isMaintenanceMode && request.url.startsWith(apiUrl)) {
          window.location.reload();
        }

        return response;
      })
    );
  }
}
